
export const VAPIDKEY = "BBpg9cvwoL-ay6nw7e4scSVNDzygBcJgn_a9kugMJDd94WucuaLV-hdCBD22fDyOdKaU44dOVK47XSJAQ147-Uo"
